(() => {
  const script = document.currentScript;
  const pageType = script?.dataset.pageType || 'unknown';
  const productHandle = script?.dataset.productHandle || '';

  const publish = (eventName, payload = {}) => {
    const eventPayload = {
      ...payload,
      page_path: window.location.pathname,
      page_type: pageType,
      product_handle: productHandle
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...eventPayload });
    document.documentElement.dataset.apexLastEvent = eventName;

    if (window.Shopify?.analytics?.publish) {
      try {
        window.Shopify.analytics.publish(eventName, eventPayload);
      } catch (error) {
        // dataLayer remains the transport fallback for custom events.
      }
    }
  };

  const whatsappLocation = (link) => {
    if (link.closest('.apx-hero')) return 'hero';
    if (link.closest('.apx-buybox, .apx-product-buybox')) return 'product_buybox';
    if (link.closest('.apx-final')) return 'final_cta';
    if (link.closest('footer')) return 'footer';
    if (pageType === 'article') return 'article';
    if (pageType === 'page') return 'page';
    return 'other';
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="wa.me/"]');
    if (link) {
      publish('click_whatsapp', {
        wa_location: link.dataset.waLocation || link.dataset.whatsappPlacement || whatsappLocation(link),
        wa_product: link.dataset.waProduct || productHandle || 'none',
        link_url: link.href
      });
      return;
    }

    const leadButton = event.target.closest('[data-lead-wa]');
    if (!leadButton) return;
    publish('click_whatsapp', {
      wa_location: 'lead_capture',
      wa_product: productHandle || 'creatina-monohidratada-micronizada-350g',
      link_url: 'whatsapp_dynamic'
    });
  });

  document.addEventListener('submit', (event) => {
    if (!event.target.matches('form[action*="/contact"]')) return;
    publish('submit_contact_form', {
      form_id: event.target.id || 'contact_form'
    });
  });

  const policyEvents = {
    '/policies/shipping-policy': 'view_shipping_policy',
    '/policies/refund-policy': 'view_refund_policy'
  };
  const policyEvent = policyEvents[window.location.pathname];
  if (policyEvent) publish(policyEvent);
  document.documentElement.dataset.apexAnalytics = 'ready';
})();
